import React from 'react';

function CrossIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        d="M15.854,8.146c-0.195-0.195-0.512-0.195-0.707,0L12,11.293L8.854,8.146c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707L11.293,12l-3.146,3.146c-0.195,0.195-0.195,0.512,0,0.707C8.244,15.951,8.372,16,8.5,16s0.256-0.049,0.354-0.146L12,12.707l3.146,3.146C15.244,15.951,15.372,16,15.5,16s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L12.707,12l3.146-3.146C16.049,8.658,16.049,8.342,15.854,8.146z"
      />
    </svg>
  );
}

export default CrossIcon;
